<template>
  <v-container class="pa-1" fluid>
    <v-sheet tile color="colorComponentsBackground" height="340px">
      <WorkplaceInputForm />
    </v-sheet>
    <v-row>
      <v-col>
        <WorkplaceTransactions />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import WorkplaceTransactions from '@/components/WorkplaceTransactions.vue';
import WorkplaceInputForm from '@/components/WorkplaceInputForm.vue';

export default Vue.extend({
  name: 'View-Workplace',
  components: {
    WorkplaceTransactions,
    WorkplaceInputForm,
  },
  mounted() {
    // this.$store.dispatch('checkLogin').catch(() => this.$router.push('/login'));
  },
  methods: {},
});
</script>
